export default {
    'event_list': '活动列表',
    'upcoming_event_list': '最近活动列表',
    'display_upcoming_event': '显示最近活动',
    'no_events': '没有任何活动...',
    'activities': '活动',
    'media-report': '传媒报导'
    // Add more translations as needed
};
